import * as ACTION from '@Bootstraps/bootstrapActions';
import * as COMPONENT from '@Components';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import clsx from 'classnames';
import '@Styles/detail.css';

export default function Page() {
  const [cloth, setCloth] = useState({});
  const [value, setValue] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const params = useParams();
  const dispatch = useDispatch();
  const { cart, clothesEntityResponse, clothesEntityError } = useSelector(state => state);

  useEffect(() => {
    if (params.slug) {
      dispatch(ACTION.clothesEntity(params.slug));
    } else {
      setCloth({});
      setLoading(true);
      setError(false);
    }
  }, [dispatch, params.slug]);

  useEffect(() => {
    if (clothesEntityResponse) {
      setCloth(clothesEntityResponse?.data);
      setTimeout(() => {
        setLoading(false);
      }, 100);
    } else if (clothesEntityError) {
      setError(true);
    }
  }, [clothesEntityResponse, clothesEntityError]);

  useEffect(() => {
    setValue(cart.filter((data) => data._id === cloth?._id)[0]?.value || 1);
  }, [cart, cloth._id, params.slug]);

  return (
    <div className="container detail placeholder-glow mt-5">
      <div className="row m-0 justify-content-between align-items-center">
        <div className="col-lg-5 detail-img p-0 m-0 mb-5 mb-lg-0">
          <COMPONENT.DetailImages image={cloth?.thumbnail} loading={loading} />
        </div>
        <div className="col-lg-6 mt-lg-0 mt-sm-5 mt-4 p-0">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="fw-semibold text-primary2">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/clothes" className="fw-semibold text-primary2">
                  Clothes
                </Link>
              </li>
              <li
                className={clsx('breadcrumb-item active', {
                  'placeholder rounded ms-3': loading,
                })}
                aria-current="page"
              >
                {cloth?.name || 'Cloth Name'}
              </li>
            </ol>
          </nav>
          <div className="desc p-0">
            <h3
              className={clsx('mt-5 fw-bold', {
                'placeholder rounded col-7 d-block': loading,
              })}
            >
              {cloth?.name || 'Cloth Name'}
            </h3>
            <h4
              className={clsx('mt-3', {
                'placeholder rounded col-4 d-block': loading,
              })}
            >
              Rp {cloth?.price?.toLocaleString('id-ID') || '999.999'},00
            </h4>
            <select
              className={clsx('form-select my-4', {
                placeholder: loading,
              })}
              id="inputGroupSelect02"
            >
              <option>Select Size</option>
              <option value="s">S</option>
              <option value="m">M</option>
              <option value="l">L</option>
              <option value="xl">XL</option>
              <option value="xxl">XXL</option>
            </select>
            <div className="qty-button mb-5">
              <input
                type="number"
                className={clsx('form-control rounded-3', {
                  placeholder: loading,
                })}
                value={value}
                onChange={(e) =>
                  setValue(e.target.value > 1 ? e.target.value : 1)
                }
                disabled={
                  loading || cart.some((item) => item._id === cloth?._id)
                }
              />
              {cart.some((item) => item._id === cloth?._id) ? (
                <button
                  className={`btn btn-dark text-white fw-semibold normal rounded-3 py-25 px-sm-4 px-5 me-sm-5 ${
                    loading && 'placeholder'
                  }`}
                  disabled={loading}
                  onClick={() =>
                    dispatch(
                      ACTION.setCart(
                        cart.filter((item) => item._id !== cloth?._id)
                      )
                    )
                  }
                >
                  <span className="me-3 text-primary2">
                    <i className="fa-solid fa-heart btn-dark"></i>
                  </span>
                  Remove from Cart
                </button>
              ) : (
                <button
                  className={`btn btn-dark text-white fw-semibold normal rounded-3 py-25 px-sm-4 px-5 me-sm-5 ${
                    loading && 'placeholder'
                  }`}
                  disabled={loading}
                  onClick={() =>
                    dispatch(
                      ACTION.setCart([...cart, { _id: cloth?._id, value }])
                    )
                  }
                >
                  <span className="me-3 text-white">
                    <i className="fa-solid fa-heart btn-dark"></i>
                  </span>
                  Add to Cart
                </button>
              )}
            </div>
            <p
              className={clsx('normal', {
                'placeholder rounded': loading,
              })}
            >
              {cloth?.description?.section1 ||
                'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Magnam maiores, sed pariatur doloribus dicta aliquam dolores corrupti in, culpa voluptatibus, illum voluptas. Ipsam aperiam quisquam temporibus architecto cupiditate quod velit!'}
            </p>
            <p
              className={clsx('normal', {
                'placeholder rounded': loading,
              })}
            >
              {cloth?.description?.section2 ||
                'Perspiciatis saepe sint hic voluptas nostrum architecto, pariatur perferendis suscipit sapiente accusantium atque quis, odio unde voluptates doloribus nam debitis quidem? Veritatis eligendi odio explicabo nulla iure voluptate assumenda delectus consequatur nemo cupiditate dolor quam, nam nihil quae. Et, dolores nobis. Quibusdam.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
